export default function ({ store, redirect, route }) {
  const activeAccount = store.state.auth.activeAccount;
  if (helpers.isEmpty(activeAccount)) {
    return redirect('/login')
  }

  const activeAccountPermissions = activeAccount.permissionNames;

  let isPass = route.meta.some((meta) => {
    if (meta.account_permission_names !== undefined) {
      return collect(meta.account_permission_names).diff(activeAccountPermissions).count() == 0;
    }

    return false;
  });


  if (!isPass) {
    if (activeAccount.type === 'ADMIN' &&
        activeAccount.university.activePackage !== undefined &&
        ['community', 'community-plus'].indexOf(activeAccount.university.activePackage.slug) === -1
      ) {
      isPass = true;
    }
  }

  if (!isPass) {
    return redirect('/panel');
  }
}
